import { render } from "./UserCreateEditFormComponent.vue?vue&type=template&id=6c851c0e&scoped=true"
import script from "./UserCreateEditFormComponent.vue?vue&type=script&lang=js"
export * from "./UserCreateEditFormComponent.vue?vue&type=script&lang=js"

import "./UserCreateEditFormComponent.vue?vue&type=style&index=0&id=6c851c0e&scoped=true&lang=css"

import exportComponent from "/tmp/build_905a1b4c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c851c0e"]])

export default __exports__